import React, { ReactNode } from 'react';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  breadcrumbRouteCreatePrivacyPolicy,
  breadcrumbRoutePrivacyPolicy
} from 'modules/Policy/breadcrumbs';
import { RootState } from 'app/reducer';
import { fetchPPDetails } from 'modules/Policy/repository';
import {
  manageThrow as manageThrowAction,
  ManageThrowAction
} from 'modules/Shared/action';
import PrivacyPolicy, {
  createPrivacyPolicy
} from 'modules/Policy/model/PrivacyPolicy';
import PrivacyPolicyForm from 'modules/Policy/component/Form/PrivacyPolicy';

export interface StateProps {
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  manageThrow: (error: Error) => ManageThrowAction;
}

export interface Props extends StateProps, DispatchProps, RouteComponentProps {
  id?: number;
}

export interface State {
  pp: PrivacyPolicy;
}

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  manageThrow: (error: Error) => dispatch(manageThrowAction(error))
});

export const mapState = (state: RootState): StateProps => {
  const { type } = state.layout.page;

  return { type };
};

class AddUpdatePrivacyPolicyView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      pp: null
    };
  }

  async componentDidMount(): Promise<void> {
    const { id, managePage, manageThrow } = this.props;

    if (id) {
      managePage({
        title: 'Privacy policy - edit',
        type: 'loading',
        breadcrumb: breadcrumbRoutePrivacyPolicy()
      });

      try {
        const { data } = await fetchPPDetails(id);

        const pp = createPrivacyPolicy(data.pp);

        this.setState({
          pp
        });

        managePage({
          title: 'Privacy policy - edit',
          type: null,
          breadcrumb: breadcrumbRoutePrivacyPolicy(pp)
        });
      } catch (error) {
        manageThrow(error);
      }
    } else {
      managePage({
        title: 'Privacy policy - create',
        breadcrumb: breadcrumbRouteCreatePrivacyPolicy()
      });
    }
  }

  render(): ReactNode {
    const { id, type } = this.props;
    const { pp } = this.state;

    if (type || (id && !pp)) {
      return null;
    }

    return (
      <div className="row justify-content-center">
        <div className="col-12 col-md-10">
          <div className="card">
            <div className="card-body">
              <PrivacyPolicyForm pp={pp} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect<StateProps, DispatchProps>(
    mapState,
    mapDispatch
  )(AddUpdatePrivacyPolicyView)
);
